import template from './companies.html';
import controller from './companies.controller';
import './companies.styl';

const companiesComponent = {
  template,
  controller,
  controllerAs: 'companies'
};

export default companiesComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies.component.js
 **/